import { createSlice } from "@reduxjs/toolkit";

import {
  getContractThunk,
  createContractThunk,
  updateContractThunk,
  deleteContractThunk,
  getDocumentContractThunk,
} from "state/action/contract";

// Initial state
const initialState = {
  // Get Contract inisial state
  getContract: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  getDocumentContract: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  createContractInputBody: {
    lease_agreement: "",
    document_lanlord: {
      url: "",
      file: "",
    },
    document_tenant: {
      url: "",
      file: "",
    },
    payment_method: "",
    rental_fee: "",
    service_charge: "",
    deposit: "",
    duration: "",
    currency: "",
    notice_period: "",
    late_payment_fee: "",
    grace_period: "",
    additional_terms: "",
    penalty_fee: "",
    payment_date: "",
    payment_schedule: "",
    status: "",
  },
  // Create Contract inisial state
  createContract: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Update Contract inisial state
  updateContract: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Delete Contract inisial state
  deleteContract: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Contract object value
  contract_object_value: "",
  selectedContract: {},
};

export const contractSlice = createSlice({
  name: "contract",
  initialState,
  reducers: {
    setGetContractObjectValue: (state, action) => {
      return {
        ...state,
        contract_object_value: action.payload,
      };
    },
    setSelectedContract: (state, action) => {
      return {
        ...state,
        selectedContract: action.payload,
      };
    },
    // note: clear state
    setClearGetContractObjectValue: (state, _) => {
      return {
        ...state,
        contract_object_value: "",
      };
    },
    setClearGetContract: (state, _) => {
      return {
        ...state,
        getContract: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearCreateContract: (state, _) => {
      return {
        ...state,
        createContract: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearUpdateContract: (state, _) => {
      return {
        ...state,
        updateContract: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearDeleteContract: (state, _) => {
      return {
        ...state,
        deleteContract: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setCreateContractInputBody: (state, action) => {
      return {
        ...state,
        createContractInputBody: action.payload,
      };
    },
    setClearCreateContractInputBody: (state, _) => {
      return {
        ...state,
        createContractInputBody: {
          lease_agreement: "",
          documentUrl: "",
          payment_method: "",
          rental_fee: "",
          service_charge: "",
          deposit: "",
          duration: "",
          currency: "",
          notice_period: "",
          late_payment_fee: "",
          grace_period: "",
          additional_terms: "",
          penalty_fee: "",
          payment_date: "",
          payment_terms: "",
          status: "",
        },
      };
    },
    setClearAllContractState: (state, _) => {
      return {
        ...state,
        // Get Contract inisial state
        getContract: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Create Contract inisial state
        createContract: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Update Contract inisial state
        updateContract: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Delete Contract inisial state
        deleteContract: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Contract object value
        Contract_object_value: "",
      };
    },
  },
  extraReducers(builder) {
    builder
      // Get Contract reducer
      .addCase(getContractThunk.pending, (state, _) => {
        return {
          ...state,
          getContract: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getContractThunk.fulfilled, (state, action) => {
        return {
          ...state,
          getContract: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getContractThunk.rejected, (state, action) => {
        return {
          ...state,
          getContract: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      .addCase(getDocumentContractThunk.pending, (state, _) => {
        return {
          ...state,
          getDocumentContract: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getDocumentContractThunk.fulfilled, (state, action) => {
        return {
          ...state,
          getDocumentContract: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getDocumentContractThunk.rejected, (state, action) => {
        return {
          ...state,
          getDocumentContract: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // Create Contract reducer
      .addCase(createContractThunk.pending, (state, _) => {
        return {
          ...state,
          register: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createContractThunk.fulfilled, (state, action) => {
        return {
          ...state,
          register: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createContractThunk.rejected, (state, action) => {
        return {
          ...state,
          register: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // update Contract reducer
      .addCase(updateContractThunk.pending, (state, _) => {
        return {
          ...state,
          updateContract: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateContractThunk.fulfilled, (state, action) => {
        return {
          ...state,
          updateContract: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateContractThunk.rejected, (state, action) => {
        return {
          ...state,
          updateContract: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      });
  },
});

export const contractAction = {
  ...contractSlice.actions,
  getContractThunk,
  getDocumentContractThunk,
  createContractThunk,
  updateContractThunk,
  deleteContractThunk,
};

export function selectContractObjectValue(state) {
  return state?.contract?.contract_object_value;
}

export function selectContract(state) {
  return state?.contract;
}

export default contractSlice.reducer;
